import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';

import { TealiumAnalyticsService } from '../../../analytics/src/lib/services/tealium-analytics.service';
import { OktaError, PopupDialogAction, PopupDialogActionOptions, PopupDialogObject, PopupDialogOptions } from '../models';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class OktaErrorHandlerService extends AbstractErrorHandlerService {
	constructor(
		public contentService: ContentService,
		public errorPopupService: ErrorPopupService,
		public tealiumAnalyticsService: TealiumAnalyticsService,
		public errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		if (error instanceof OktaError) {
			const failedMessage = PopupDialogObject.create({
				success: false,
				title: this.contentService.get('OKTA_ERROR_TITLE', 'Something went wrong'),
				description: this.contentService.get(`OKTA_${error.errorCode}`, `${error.errorCode}: ${error.errorMessage}`),
				actions: [
					PopupDialogAction.create({
						description: this.contentService.get('OKTA_ERROR_RETRY_DESC', 'Please try again.'),
						label: this.contentService.get('OKTA_ERROR_RETRY_LABEL', 'Retry'),
						url: error.url
					} as PopupDialogActionOptions)
				]
			} as PopupDialogOptions);
			this.errorPopupService.openResponseMessageDialog(failedMessage);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
